var map = {
	"./bnr1.jpg": 27,
	"./bnr10.jpg": 28,
	"./bnr11.jpg": 95,
	"./bnr12.jpg": 96,
	"./bnr13.jpg": 97,
	"./bnr14.jpg": 98,
	"./bnr2.jpg": 99,
	"./bnr3.jpg": 100,
	"./bnr4.jpg": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;